import {gsap} from "gsap";
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import Header from '../layout/header';

gsap.registerPlugin(ScrollToPlugin);

const anchorsScroll = {

  init: function () {

    function smoothScroll(target) {
      gsap.to(window, {
        duration: 0.7,
        scrollTo: {
          y: target,
          offsetY: 50,
          autoKill: false,
        },
        ease: "ease.inOut",
      });
    }

    let anchors = document.querySelectorAll('a[href^="#"]');
    anchors.forEach(function (anchor) {
      anchor.addEventListener("click", function (e) {
        e.preventDefault();
        let target = document.querySelector(this.getAttribute("href"));
        if (target) {
          smoothScroll(target);
          Header.closeMobileNav();
        } else {
          let linkTarget = this.getAttribute("target") ? this.getAttribute("target") : '_self'
          window.open(this.getAttribute("href"), linkTarget);
        }
      });
    });
  },
}

export default anchorsScroll;
